import { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const navLinks = [
  { label: 'Home', href: '/', isHash: false },
  { label: 'Categories', href: '#categories', isHash: true },
  { label: 'Trending', href: '#trending', isHash: true },
  { label: 'Shopping Guide', href: '#blog', isHash: true },
];

const categories = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', image: 'https://readdy.ai/api/search-image?query=elegant%20high-end%20leather%20sneakers%20on%20polished%20marble%20surface%20with%20soft%20dramatic%20studio%20lighting%20editorial%20fashion%20photography&width=200&height=200&seq=cat-shoes-nav&orientation=squarish' },
  { name: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', image: 'https://readdy.ai/api/search-image?query=cozy%20oversized%20knit%20sweater%20draped%20on%20vintage%20wooden%20chair%20warm%20natural%20light%20lifestyle%20photography&width=200&height=200&seq=cat-hoodie-nav&orientation=squarish' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', image: 'https://readdy.ai/api/search-image?query=crisp%20white%20cotton%20t-shirt%20on%20folded%20linen%20fabric%20soft%20daylight%20minimalist%20product%20photography&width=200&height=200&seq=cat-tee-nav&orientation=squarish' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', image: 'https://readdy.ai/api/search-image?query=stylish%20bomber%20jacket%20hanging%20on%20industrial%20metal%20hook%20against%20exposed%20brick%20wall&width=200&height=200&seq=cat-jacket-nav&orientation=squarish' },
  { name: 'Pants/Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', image: 'https://readdy.ai/api/search-image?query=tailored%20chino%20pants%20neatly%20folded%20on%20raw%20concrete%20pedestal%20modern%20editorial%20photography&width=200&height=200&seq=cat-pants-nav&orientation=squarish' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', image: 'https://readdy.ai/api/search-image?query=trendy%20streetwear%20baseball%20cap%20on%20weathered%20wooden%20surface%20golden%20hour%20warm%20light&width=200&height=200&seq=cat-hat-nav&orientation=squarish' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', image: 'https://readdy.ai/api/search-image?query=matching%20monochrome%20outfit%20layflat%20on%20textured%20jute%20rug%20top%20view%20fashion%20styling&width=200&height=200&seq=cat-sets-nav&orientation=squarish' },
  { name: 'Underwear', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', image: 'https://readdy.ai/api/search-image?query=premium%20cotton%20underwear%20folded%20on%20soft%20merino%20wool%20blanket%20clean%20minimal%20product%20shot&width=200&height=200&seq=cat-under-nav&orientation=squarish' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', image: 'https://readdy.ai/api/search-image?query=vintage%20sport%20jersey%20hanging%20in%20locker%20room%20with%20neon%20light%20reflection&width=200&height=200&seq=cat-jersey-nav&orientation=squarish' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', image: 'https://readdy.ai/api/search-image?query=curated%20fashion%20accessories%20collection%20on%20leather%20tray%20watches%20sunglasses%20jewelry&width=200&height=200&seq=cat-acc-nav&orientation=squarish' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', image: 'https://readdy.ai/api/search-image?query=luxury%20canvas%20tote%20bag%20on%20vintage%20steamer%20trunk%20travel%20editorial%20photography&width=200&height=200&seq=cat-bag-nav&orientation=squarish' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', image: 'https://readdy.ai/api/search-image?query=handcrafted%20leather%20belt%20coiled%20on%20aged%20oak%20wine%20barrel%20warm%20rustic%20light&width=200&height=200&seq=cat-belt-nav&orientation=squarish' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', image: 'https://readdy.ai/api/search-image?query=elegant%20amber%20glass%20perfume%20bottle%20on%20crystal%20shelf%20soft%20diffused%20light%20luxury%20product&width=200&height=200&seq=cat-perfume-nav&orientation=squarish' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', image: 'https://readdy.ai/api/search-image?query=eclectic%20mix%20of%20lifestyle%20products%20on%20bamboo%20mat%20creative%20curated%20collection%20photography&width=200&height=200&seq=cat-other-nav&orientation=squarish' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [catDropdownOpen, setCatDropdownOpen] = useState(false);
  const [mobileCatOpen, setMobileCatOpen] = useState(false);
  const catRef = useRef<HTMLDivElement>(null);
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (catRef.current && !catRef.current.contains(e.target as Node)) {
        setCatDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string, isHash: boolean) => {
    if (isHash && isHome) {
      e.preventDefault();
      const el = document.getElementById(href.replace('#', ''));
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
      setMobileMenuOpen(false);
      setCatDropdownOpen(false);
    } else if (isHash && !isHome) {
      e.preventDefault();
      navigate('/' + href);
      setMobileMenuOpen(false);
      setCatDropdownOpen(false);
    } else {
      setMobileMenuOpen(false);
      setCatDropdownOpen(false);
    }
  };

  const isTransparent = !scrolled && isHome;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isTransparent
          ? 'bg-black/20 backdrop-blur-[3px]'
          : 'bg-background-50/95 backdrop-blur-md border-b border-background-200'
      }`}
    >
      <div className="flex items-center justify-between px-5 md:px-8 lg:px-12 py-3 md:py-4">
        {/* Logo */}
        <Link
          to="/"
          className={`text-lg md:text-xl font-bold tracking-tight whitespace-nowrap ${
            isTransparent ? 'text-white drop-shadow-md' : 'text-foreground-950'
          }`}
        >
          Pandabuy<span className="font-light">Spreadsheet</span>
        </Link>

        {/* Desktop Nav Links + Buttons */}
        <div className="hidden md:flex items-center gap-6 lg:gap-8">
          {navLinks.map((link) => (
            <div key={link.label} className="relative" ref={link.label === 'Categories' ? catRef : undefined}>
              {link.label === 'Categories' ? (
                <button
                  onClick={() => setCatDropdownOpen(!catDropdownOpen)}
                  className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1 ${
                    isTransparent
                      ? 'text-white/90 hover:text-white drop-shadow-sm'
                      : 'text-foreground-600 hover:text-foreground-950'
                  }`}
                >
                  {link.label}
                  <i className={`ri-arrow-down-s-line transition-transform ${catDropdownOpen ? 'rotate-180' : ''}`}></i>
                </button>
              ) : (
                <a
                  href={link.href}
                  onClick={(e) => handleNavClick(e, link.href, link.isHash)}
                  className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    isTransparent
                      ? 'text-white/90 hover:text-white drop-shadow-sm'
                      : 'text-foreground-600 hover:text-foreground-950'
                  }`}
                >
                  {link.label}
                </a>
              )}

              {/* Desktop Category Mega Dropdown */}
              {link.label === 'Categories' && catDropdownOpen && (
                <div className="absolute top-full left-1/2 -translate-x-1/2 mt-3 w-[700px] bg-background-50 rounded-xl shadow-xl border border-background-200 p-5 grid grid-cols-3 gap-3">
                  {categories.map((cat) => (
                    <a
                      key={cat.name}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="flex items-center gap-3 p-2.5 rounded-lg hover:bg-background-100 transition-colors group"
                    >
                      <img src={cat.image} alt={cat.name} className="w-10 h-10 rounded-md object-cover shrink-0" />
                      <span className="text-sm font-medium text-foreground-700 group-hover:text-foreground-950">
                        {cat.name}
                      </span>
                    </a>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Desktop CTA Buttons */}
        <div className="hidden md:flex items-center gap-3">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className={`px-4 lg:px-5 py-2 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${
              isTransparent
                ? 'bg-white/25 text-white hover:bg-white/35 border border-white/30'
                : 'bg-background-200 text-foreground-800 hover:bg-background-300'
            }`}
          >
            Pandabuy Sheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-4 lg:px-5 py-2 rounded-full bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Buy It Now
          </a>
        </div>

        {/* Mobile Hamburger */}
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
            isTransparent ? 'text-white' : 'text-foreground-950'
          }`}
        >
          <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {/* Mobile Menu Panel */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 shadow-xl max-h-[85vh] overflow-y-auto">
          <div className="flex flex-col px-5 py-4 gap-1">
            {/* Home */}
            <Link
              to="/"
              onClick={() => setMobileMenuOpen(false)}
              className="text-sm font-medium text-foreground-700 py-3 border-b border-background-100"
            >
              Home
            </Link>

            {/* Categories with expand */}
            <div className="border-b border-background-100">
              <button
                onClick={() => setMobileCatOpen(!mobileCatOpen)}
                className="w-full flex items-center justify-between text-sm font-medium text-foreground-700 py-3"
              >
                <span>Categories</span>
                <i className={`ri-arrow-down-s-line text-lg transition-transform ${mobileCatOpen ? 'rotate-180' : ''}`}></i>
              </button>
              {mobileCatOpen && (
                <div className="grid grid-cols-2 gap-2 pb-3">
                  {categories.map((cat) => (
                    <a
                      key={cat.name}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="flex items-center gap-2.5 p-2 rounded-lg hover:bg-background-100 transition-colors"
                    >
                      <img src={cat.image} alt={cat.name} className="w-8 h-8 rounded object-cover shrink-0" />
                      <span className="text-xs font-medium text-foreground-700">{cat.name}</span>
                    </a>
                  ))}
                </div>
              )}
            </div>

            {/* Trending */}
            <a
              href="#trending"
              onClick={(e) => handleNavClick(e, '#trending', true)}
              className="text-sm font-medium text-foreground-700 py-3 border-b border-background-100"
            >
              Trending
            </a>

            {/* Shopping Guide */}
            <a
              href="#blog"
              onClick={(e) => handleNavClick(e, '#blog', true)}
              className="text-sm font-medium text-foreground-700 py-3 border-b border-background-100"
            >
              Shopping Guide
            </a>

            {/* Mobile CTAs */}
            <div className="flex gap-3 pt-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="flex-1 text-center px-4 py-2.5 rounded-full bg-foreground-950 text-white text-sm font-semibold whitespace-nowrap cursor-pointer"
              >
                Pandabuy Sheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="flex-1 text-center px-4 py-2.5 rounded-full bg-primary-500 text-white text-sm font-semibold whitespace-nowrap cursor-pointer"
              >
                Buy It Now
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}